import { AxiosError } from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { DellWarranty } from "../models/DellWarranty";
import { RootState } from "../store/store";
import { getAuthorizedApi, processAxiosError } from "./common.service";


export const getWarrantyBySerials = createAsyncThunk<
    DellWarranty[],
    string,
    { state: RootState }
>(
    "dellWarranty/getDellWarrantyBySerial",
    async (serial, { dispatch }) => {
        try {
            const response = await getAuthorizedApi().get<DellWarranty[]>("/DellWarranty/GetDellWarranty?serial=" + encodeURIComponent(serial));
            return response.data;
        } catch (err) {
            const error = err as AxiosError;
            processAxiosError(error, dispatch);
        }
        return [];
    },
    {
        // Skip the fetch if we already have warranty data for this exact serial string
        // (or a fetch for it is already in flight). Prevents N identical requests when
        // multiple ItemCollapsable instances mount for the same order, and avoids
        // re-fetching on re-open.
        condition: (serial, { getState }) => {
            const { fetchedKey, loading } = getState().dellWarranty;
            const key = (serial ?? "").trim();
            if (!key) return false;
            if (loading) return false;
            if (fetchedKey === key) return false;
            return true;
        },
    }
);
